export default {
  // Page title
  'page.title': 'Stopwatch',

  // How to use
  'howto.title': 'Cara Menggunakan',
  'howto.step1': 'Klik tombol "Mulai" untuk memulai stopwatch, format tampilan: menit:detik.sentidetik',
  'howto.step2': 'Klik "Jeda" untuk menjeda waktu ketika stopwatch berjalan, klik "Mulai" lagi untuk melanjutkan',
  'howto.step3': 'Klik tombol "Atur Ulang" untuk mengatur ulang stopwatch ke nol dan menghentikan waktu',
  'howto.step4': 'Stopwatch mendukung tampilan presisi milidetik, cocok untuk skenario yang memerlukan waktu yang tepat',

  // User reviews
  'reviews.title': 'Ulasan Pengguna',
  'reviews.michaelRunner': 'Alat latihan penting! Presisi milidetik memungkinkan saya merekam setiap kinerja sprint secara akurat, operasi sederhana dan cepat.',
  'reviews.chefJohnson': 'Keajaiban timer memasak! Menumis, merebus mie, mengukus telur semuanya membutuhkan waktu yang tepat, stopwatch ini membantu saya membuat hidangan sempurna.',
  'reviews.sarahStudent': 'Penting untuk simulasi ujian! Digunakan untuk berlatih waktu menjawab, antarmuka bersih tidak akan mengalihkan perhatian, meningkatkan efisiensi menjawab.',
  'reviews.coachWilliams': 'Asisten hebat untuk kursus pelatihan! Latihan interval dan plank membutuhkan waktu yang tepat, siswa menyukainya.',
  'reviews.drAnderson': 'Pekerjaan medis sering memerlukan waktu yang tepat, stopwatch ini sederhana dan andal, asisten hebat untuk pekerjaan klinis saya.',

  // User names
  'user.michaelRunner': 'Michael Runner',
  'user.chefJohnson': 'Chef Johnson',
  'user.sarahStudent': 'Sarah Student',
  'user.coachWilliams': 'Coach Williams',
  'user.drAnderson': 'Dr. Anderson',

  // Keywords section
  'keywords.stopwatch': 'stopwatch timer waktu presisi jam berapa sekarang',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};
